"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var R = _interopRequireWildcard(require("ramda"));

var _codemirror = _interopRequireDefault(require("codemirror/lib/codemirror.js"));

var _reactCodemirror = _interopRequireDefault(require("react-codemirror"));

require("codemirror/mode/xml/xml");

require("codemirror/mode/css/css");

require("codemirror/mode/javascript/javascript");

require("codemirror/mode/htmlmixed/htmlmixed");

require("codemirror/mode/markdown/markdown");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

require('!style-loader!css-loader!codemirror/lib/codemirror.css');

var Styled = (
/*#__PURE__*/
0, _styledBase.default)(_reactCodemirror.default, {
  target: "e1hhwchy0"
})(".CodeMirror{font-size:", function (props) {
  return props.theme.fonts.size[2];
}, "px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var config = {
  lineWrapping: true,
  lineNumbers: true,
  tabSize: 2,
  mode: 'htmlmixed'
};
var Component = R.pipe(function (_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      options = _ref.options,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["value", "onChange", "options", "disabled"]);

  var editorRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      internvalValue = _useState2[0],
      setInternalValue = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      editorInstance = _useState4[0],
      setEditorInstance = _useState4[1];

  (0, _react.useEffect)(function () {
    // to prevent content redrawing and reseting cursor position
    if (editorInstance && value !== internvalValue) {
      editorInstance.setValue(value);
    }
  }, [value]);
  (0, _react.useEffect)(function () {
    if (editorRef) {
      setEditorInstance(editorRef.current.getCodeMirror());
    } else {
      setEditorInstance(null);
    }
  }, [editorRef]);
  return _objectSpread({
    editorRef: editorRef,
    internvalValue: internvalValue,
    setInternalValue: setInternalValue,
    onChange: function onChange(code) {
      setInternalValue(code);

      _onChange(code);
    },
    options: R.mergeDeepRight(config, _objectSpread({}, options, {
      readOnly: disabled
    }))
  }, rest);
}, function (_ref2) {
  var internvalValue = _ref2.internvalValue,
      onChange = _ref2.onChange,
      options = _ref2.options,
      name = _ref2.name,
      editorRef = _ref2.editorRef,
      rest = _objectWithoutProperties(_ref2, ["internvalValue", "onChange", "options", "name", "editorRef"]);

  return (0, _core.jsx)(Styled, _extends({
    value: internvalValue,
    onChange: onChange,
    options: options,
    name: name,
    codeMirrorInstance: _codemirror.default,
    ref: editorRef
  }, rest));
});
Component.displayName = 'CodeEditor';
Component.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  options: _propTypes.default.object,
  name: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
Component.defaultProps = {
  value: '',
  onChange: function onChange() {},
  options: {},
  disabled: false
};
var _default = Component;
exports.default = _default;